export const checkNoChosenYears = (years: string[], chosenYears: string[], academicYearsTouched: boolean) => {
  // Если пользователь не изменял значения в комбике учебных готов, то считаем, что выбраны все года
  if (!academicYearsTouched) {
    return years.length === 0;
  }

  return !years.some((year) => chosenYears.includes(year));
};
